import { SearchObject, SearchClientCard } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import {
  deleteClientCard,
  getClientCardById,
  pagingClientCard,
  saveOrEditClientCard,
} from "app/services/ClientCardService";
import {
  downloadClientCard,
  importExcelClienrCard,
  downloadClientCardFee,
  importExcelClienrCardFee,
  downloadClientCardScope,
  importExcelClienrCardScope,
  downloadClientCardRevenueAllocation,
  importExcelClienrCardRevenueAllocation,
} from "app/services/ImportExcelService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

import moment from "moment";

const DEFAULT_VALUE = {
  name: "",
  code: "",
  isUsing: true,
  vatIncluded: true,
  useAllServices: true,
  useAllProduct: true,
  multiUserCard: false,
  serviceVATs: [],
  isTotalPriceUsed: true,
  isEditable: true,
};

export default class ClientCardStore {
  open = false;
  openInfoService = false;
  openConfirm = false;
  pageCustomerList = new PageResponse();
  searchPage = new SearchClientCard();
  documentData = null;
  selectValue = { ...DEFAULT_VALUE };
  selectedRowClientCard = null;
  constructor() {
    makeAutoObservable(this);
  }

  setSelectedRowClientCard = (row) => {
    this.selectedRowClientCard = row;
  };

  pagingClientCard = () => {
    let { patientTypeServiceIds, departmentApplyIds, ...ortherData } = this.searchPage;
    if (Array.isArray(patientTypeServiceIds)) {
      ortherData.patientTypeServiceIds = patientTypeServiceIds.map(
        (item) => item?.id || item
      );
    }
    if (Array.isArray(departmentApplyIds)) {
      ortherData.departmentApplyIds = departmentApplyIds.map((item) => item?.id || item);
    }
    pagingClientCard(ortherData)
      .then(({ data }) => {
        // console.log("Dữ liệu danh sách khách hàng:", data);
        this.pageCustomerList = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu không thành công");
      });
  };

  setOpenInfoService = (state) => {
    this.openInfoService = state;
  };

  handleChangeFormSearch = (searchPage) => {
    this.searchPage = { ...this.searchPage, ...searchPage };
    this.pagingClientCard();
  };

  handleGetById = async (id) => {
    try {
      const { data } = await getClientCardById(id);
      this.selectValue = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  handleOpenForm = async (id) => {
    if (Boolean(id)) {
      await this.handleGetById(id);
    }
    this.open = true;
  };

  handleEditForm = (obj) => {
    this.selectValue = obj;
    this.open = true;
  };

  handleCloseForm = () => {
    this.open = false;
    this.selectValue = { ...DEFAULT_VALUE };
    this.openConfirm = false;
  };

  saveOrEditCustomerCard = async (obj) => {
    let { patient, ...ortherData } = obj;
    if (patient) {
      ortherData.patientCode = patient?.code;
      ortherData.patientName = patient?.displayName;
      ortherData.patient = patient;
    }

    try {
      const { data } = await saveOrEditClientCard(ortherData);
      this.pagingClientCard();
      this.handleCloseForm();
      toast.success("Lưu thành công");
      return data;
    } catch (error) {
      console.log(error);
      toast.error("Lưu thất bại!!");
    }
  };

  handleOpenConfirm = (id) => {
    this.openConfirm = id;
  };

  handleRemoveCustomerCard = async () => {
    deleteClientCard(this.openConfirm)
      .then(() => {
        toast.success("Xóa thành công");
        this.pagingClientCard();
      })
      .catch(() => {
        toast.error("Xóa thất bại");
      })
      .finally(() => {
        this.handleCloseForm();
      });
  };

  handleImportExcelClientCard = (file) => {
    importExcelClienrCard(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchPage = {
          ...this.searchPage,
          pageIndex: 1,
        };
        this.pagingClientCard();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      });
  };

  handleImportExcelClientCardFee = (file) => {
    importExcelClienrCardFee(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchPage = {
          ...this.searchPage,
          pageIndex: 1,
        };
        this.pagingClientCard();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      });
  };

  handleImportExcelClientCardScope = (file) => {
    importExcelClienrCardScope(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchPage = {
          ...this.searchPage,
          pageIndex: 1,
        };
        this.pagingClientCard();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      });
  };

  handleImportExcelClientCardRevenueAllocation = (file) => {
    importExcelClienrCardRevenueAllocation(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchPage = {
          ...this.searchPage,
          pageIndex: 1,
        };
        this.pagingClientCard();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      });
  };

  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadClientCard();
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "MAU_THE.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  handleDownloadExcelTemplateClientCardFee = async () => {
    try {
      const response = await downloadClientCardFee();
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "MAU_GIA_THE.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  handleDownloadExcelTemplateClientCardScope = async () => {
    try {
      const response = await downloadClientCardScope();
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "MAU_DINH_MUC_THE.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  handleDownloadExcelTemplateClientCardRevenueAllocation = async () => {
    try {
      const response = await downloadClientCardRevenueAllocation();
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "MAU_PHAN_BO_DOANH_THU_THE.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  resetStore = () => {
    this.pageCustomerList = new PageResponse();
    this.searchPage = new SearchObject();
    this.open = false;
    this.openConfirm = false;
    this.selectValue = { ...DEFAULT_VALUE };
  };
}
